module.exports = __webpack_public_path__ + "media/images/intro-profile-pic-4b9bd2eed91416abf43038dcebed58f5.svg";